export class IncidentDataParser {
    static getUpdateCurrentMinute(element) {
        return Math.floor((new Date().getTime() - element.getTime()) / 60000);
    }
    static parse(incident, names) {
        const actualTime = new Date(incident.timeInUTC);
        return {
            id: `${incident.id}`,
            gamePart: incident.inGamePart,
            gameTime: incident.timeInGame.toString(),
            type: incident.type,
            minute: this.getUpdateCurrentMinute(actualTime),
            incidentActualTime: actualTime,
            participant: this.getParticipantName(names, `${incident.participantMapping}`)
        };
    }
    static getParticipantName(names, key) {
        return (names && names[key]) ? names[key] : "";
    }
}
//# sourceMappingURL=IncidentDataParser.js.map